// composables/useZoomShortcuts.js
import { useEventListener } from '@vueuse/core'

export function useZoomShortcuts(options) {
  const zoomIn = options.zoomIn
  const zoomOut = options.zoomOut
  const target = options.target || window

  // keyboard shortcuts: Meta/Ctrl + / -
  useEventListener(target, 'keydown', (event) => {
    const metaLike = event.metaKey || event.ctrlKey
    if (!metaLike) return

    const isPlus =
      event.key === '+' ||
      event.key === '=' ||
      event.code === 'Equal' ||
      event.code === 'NumpadAdd'

    if (isPlus) {
      event.preventDefault()
      zoomIn && zoomIn()
      return
    }

    const isMinus =
      event.key === '-' ||
      event.code === 'Minus' ||
      event.code === 'NumpadSubtract'

    if (isMinus) {
      event.preventDefault()
      zoomOut && zoomOut()
    }
  })

  // --- Mousewheel / trackpad: Meta/Ctrl + scroll
  useEventListener(
    target,
    'wheel',
    (event) => {
      const metaLike = event.metaKey || event.ctrlKey
      if (!metaLike) return

      event.preventDefault()

      // deltaY < 0 = scroll up / pinch out → zoom in
      if (event.deltaY < 0) {
        zoomIn && zoomIn()
      } else if (event.deltaY > 0) {
        zoomOut && zoomOut()
      }
    },
    // need passive: false so preventDefault() works
    { passive: false }
  )
}
